
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';

import Introduction from './Introduction';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

function Documentation() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Stack direction='column' spacing={4} margin={4}>
          <Typography variant="h3" component="div">
            Combleau Documentation
          </Typography>

          <Box
            sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex'}}
          >
          <Link
            href="/"
          >
            Back to Startpage
          </Link>
        </Box>

      <Box
        sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', borderTop: 2, borderColor: 'divider'}}
      >
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          scrollButtons={false}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{ borderRight: 2, borderColor: 'divider' }}
        >
          <Tab label="Introduction" {...a11yProps(0)} />
          <Tab label="Installation" {...a11yProps(1)} />
          <Tab label="Layout" {...a11yProps(2)} />
          <Tab label="Dimensions" {...a11yProps(3)} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <Introduction />
        </TabPanel>
        <TabPanel value={value} index={1}>
          Item One
        </TabPanel>
        <TabPanel value={value} index={2}>
          Item Two
        </TabPanel>
        <TabPanel value={value} index={3}>
          Item Three
        </TabPanel>
      </Box>
    </Stack>
  );
}

export default Documentation;
